import AddCircleOutlineIcon from 'mdi-react/AddCircleOutlineIcon';
import React, { useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useToggle } from '../../hooks';
import Header from '../App/Header/Header';
import KeywordTypeModal from './KeywordListModal/KeywordTypeModal';
import KeywordTypeList from './KeywordTypeList/KeywordTypeList';
import "./KeywordList.scss";

export const KeywordList = ({user}) => {
    const [showModal, toggleShowModal] = useToggle(false);
    const [shouldRefresh, toggleShouldRefresh] = useToggle(false);
    const [action, setAction] = useState([]);
    const [show, setShow] = useState(false);

    // const history = useHistory();

    const handleCloseModal = () => {
        toggleShowModal();
        toggleShouldRefresh();
    }

    const setAlertShow = (val) => {
        setShow(val);
    }

    const isaddOrUpdate = (response) => {
        // setAction({response, ...action});
        setAction({response});
    }

    return (
    <>
        <Header user={user} title={"Keywords"} />
        <Container className='MainContent keywordsList'>
            <Row className=" mb-3">
                <Col xs={12} className='mt-3 mb-3 '>
                    <div className="sticky-custom w-100 mb-4">
                        <Button variant='default' className='add-button btn-outline-deal-style roundedEdges' size='xs' onClick={toggleShowModal}>
                            <AddCircleOutlineIcon className='p-1' />
                            <span className="keyWLittleDown">Add Keyword</span>
                        </Button>
                    </div>
                    <KeywordTypeList refresh={shouldRefresh} action={action} show={show} setAlertShow={setAlertShow} />
                </Col>
            </Row>
            <KeywordTypeModal show={showModal} onClose={handleCloseModal} userAction={isaddOrUpdate} setAlertShow={setAlertShow} />
        </Container>
    </>
  )
}

export default KeywordList;
